import React from "react";
import style from "./Title.module.css";

export const Title = ({
  title,
  text,
  mt,
  mb,
  color = "black",
  as: Heading = "h2",
}) => {
  return (
    <div className={style.titleBox} style={{ marginBottom: mb, marginTop: mt }}>
      <div className={style.titleLine} />
      <Heading style={{ color }} className={style.blockTitle}>
        {title}
      </Heading>
      {text && (
        <p style={{ color }} className={style.blockText}>
          {text}
        </p>
      )}
    </div>
  );
};
